// ASP Tags
import GoogleTag from 'asp/bridge/Google';
import SphereTag from 'asp/bridge/Sphere';
import RentracksTag from 'asp/bridge/Rentracks';
import A8netTag from 'asp/bridge/A8net';

const AspTags = () => {
  return (
    <>
      <GoogleTag />
      <RentracksTag />
      <SphereTag />
      <A8netTag />
    </>
  );
};
export default AspTags;
